let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dNZRY")).then(() => parcelRequire('lvDtw'));